import {getFile} from "./getFile";
import {downloadFile} from "./downloadFile";
import store from "../../store/store";
import {notify} from "reapop";
import i18n from "../../i18n";
import {myID} from "../../libs/generateID";

/**
 * Czy przegladarka w ogole umie sie dzielic plikami - bez tego przycisk
 * udostepniania nie ma czego odpalic, wiec nie pokazujemy go wcale
 */
export function isFileSharingSupported() {
    return (
        typeof navigator !== "undefined" &&
        typeof navigator.share === "function" &&
        typeof navigator.canShare === "function"
    );
}

async function fetchFileAsFile({FileID, FileName, FarmID, Type}) {
    // po podpisany link idziemy tak samo jak pobieranie - obiekt na S3 jest
    // prywatny, wiec bez podpisu fetch nie ma czego wziac
    const url = await getFile(FileID, {FarmID});
    const response = await fetch(url);
    if (!response.ok) {
        throw new Error(`Fetch file failed with status ${response.status}`);
    }
    const blob = await response.blob();
    const type = blob.type || Type || "application/octet-stream";
    return new File([blob], FileName || FileID, {type});
}

/**
 * Udostepnia plik z S3 - pobiera go do bloba i wrzuca do Web Share API jako
 * plik, zeby odbiorca dostal sam plik, a nie link, ktory i tak wygasa razem
 * z podpisem.
 *
 * Gdy przegladarka nie umie dzielic sie plikami (brak Web Share API level 2),
 * plik ladujemy na dysk - uzytkownik udostepnia go dalej sam.
 */
export async function shareFile(file) {
    const {FileID} = file || {};
    if (!FileID) return;

    let fileToShare;
    try {
        fileToShare = await fetchFileAsFile(file);
    } catch (e) {
        shareFileNotificationFailure();
        return;
    }

    const data = {files: [fileToShare], title: fileToShare.name};

    if (!navigator.canShare?.(data)) {
        downloadFile(file);
        shareFileNotificationUnsupported();
        return;
    }

    try {
        await navigator.share(data);
    } catch (e) {
        // uzytkownik zamknal systemowy dialog - nie ma czego zglaszac
        if (e?.name === "AbortError") return;
        shareFileNotificationFailure();
    }
}

export function shareFileNotificationUnsupported({uniqueId = myID()} = {}) {
    store.dispatch(
        notify({
            id: uniqueId,
            title: i18n.t("share"),
            message: i18n.t("shareNotSupported"),
            status: "info",
            dismissible: true,
            dismissAfter: 5000,
        })
    );
}

export function shareFileNotificationFailure({uniqueId = myID()} = {}) {
    store.dispatch(
        notify({
            id: uniqueId,
            title: i18n.t("share"),
            message: i18n.t("shareFailure"),
            status: "error",
            dismissible: true,
            dismissAfter: 15000,
        })
    );
}
